import { authService } from './authService';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export interface EmailNotificationSettings {
  notification_from_email: string | null;
  notification_from_name: string | null;
  contact_form_to_email: string | null;
  contact_form_cc_emails: string[] | null;
  enable_contact_notifications: boolean;
  newsletter_form_to_email: string | null;
  newsletter_form_cc_emails: string[] | null;
  enable_newsletter_notifications: boolean;
  quiz_form_to_email: string | null;
  quiz_form_cc_emails: string[] | null;
  enable_quiz_notifications: boolean;
}

class EmailNotificationService {
  /**
   * Get current email notification settings
   */
  async getSettings(): Promise<EmailNotificationSettings> {
    const token = authService.getToken();
    const response = await fetch(`${API_BASE_URL}/api/email-notifications/settings`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch email notification settings');
    }

    const data = await response.json();
    return data.settings;
  }

  /**
   * Update email notification settings
   */
  async updateSettings(settings: Partial<EmailNotificationSettings>): Promise<void> {
    const token = authService.getToken();
    const response = await fetch(`${API_BASE_URL}/api/email-notifications/settings`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify(settings),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Failed to update email notification settings');
    }
  }

  /**
   * Send test email
   */
  async sendTestEmail(testEmail: string): Promise<void> {
    const token = authService.getToken();
    const response = await fetch(`${API_BASE_URL}/api/email-notifications/test`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({ test_email: testEmail }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Failed to send test email');
    }
  }
}

export const emailNotificationService = new EmailNotificationService();
